import { AnchorTarget } from '../../../../components/blackrock/advisor-center/_types/anchor-target';
import { CookieToasterTranslation } from '../../../../_helpers/manageCookies';
import { SignInDialogTranslation } from '../../../../components/blackrock/advisor-center/sign-in-dialog/SignInDialog';

export enum Themes {
	DARK = 'DARK',
	LIGHT = 'LIGHT',
}

export enum TimeSpans {
	Days = 'xDays',
	Months = 'xMonths',
	Years = 'xYears',
	Hours = 'xHours',
	Minutes = 'xMinutes',
}

export type Answer = {
	answer: string;
	votes: number;
	dataLinkEvent: string;
};

export type CTAWithIntro = {
	answerIndex: number;
	callToAction: {
		url: string;
		label: string;
		target?: AnchorTarget;
		dataLinkEvent?: string;
		ariaLabel?: string;
	};
	description?: string;
};

export type PollProps = {
	poll: PollPropsData;
	simpleVoteCountUrl?: string;
	liveVoteCountFetchSeconds: number;
	voteUrl: string;
	fullWidthAnimation: boolean;
};

export type PollTimeSpanTranslations = {
	day: string;
	days: string;
	hour: string;
	hours: string;
	minute: string;
	minutes: string;
	week: string;
	weeks: string;
	month: string;
	months: string;
	year: string;
	years: string;
};

export type PollTranslation = {
	left: string;
	viewPastResults: string;
	votes: string;
	vote: string;
	yourVote: string;
	pollClosed: string;
	timeSpan: PollTimeSpanTranslations;
};

export type PollPropsData = {
	translationMap: {
		cookieToaster?: CookieToasterTranslation;
		poll: PollTranslation;
		signInDialog: SignInDialogTranslation;
	};
	id: string;
	eyebrow: string;
	question: string;
	userVote?: number;
	answers: Answer[];
	expiryDate: number;
	startDate: number;
	theme: 'DARK' | 'LIGHT';
	ctaContainers?: CTAWithIntro[];
	pastPollResults?: unknown;
	pendingDataLinkEvent?: string;
};
